// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownSquareFilledSvg from "@ant-design/icons-svg/es/asn/DownSquareFilled";
import AntdIcon from '../components/AntdIcon';

var DownSquareFilled = function DownSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareFilledSvg
  }));
};

DownSquareFilled.displayName = 'DownSquareFilled';
export default React.forwardRef(DownSquareFilled);